import React from 'react';
import PropTypes from 'prop-types';
import { Zap } from 'lucide-react';
import {
  Display,
  Text,
  Stack,
} from '@/components/ui/index.js';
import styles from './WelcomeStep.module.css';

/**
 * WelcomeStep - First step of onboarding
 * 
 * Displays:
 * - Animated app logo with glow effect
 * - Welcome heading
 * - Tagline description
 * - Get Started CTA button
 */
export function WelcomeStep({ onGetStarted }) {
  return (
    <Stack direction="column" gap={8} align="center" className={styles.container}>
      {/* Logo with glow */}
      <div className={styles.logoWrapper}>
        <div className={styles.logoGlow} />
        <div className={styles.logo}>
          <Zap size={48} className={styles.logoIcon} />
        </div>
      </div>

      {/* Welcome text */}
      <Stack direction="column" gap={4} align="center" className={styles.textSection}>
        <Display 
          size="xl" 
          weight="black" 
          color="primary" 
          align="center"
          shadow
        >
          Welcome to SportsSpots
        </Display>
        
        <Text 
          size="lg" 
          color="secondary" 
          align="center"
          leading="relaxed"
          className={styles.tagline}
        >
          Find local sports activities, connect with athletes, 
          and discover new venues in your area.
        </Text>
      </Stack>

      {/* CTA Button */}
      <button 
        type="button"
        onClick={onGetStarted}
        className={styles.ctaButton}
      >
        <span className={styles.ctaButtonText}>Get Started</span>
        <span className={styles.ctaButtonGlow} />
      </button>
    </Stack>
  );
}

WelcomeStep.propTypes = {
  onGetStarted: PropTypes.func.isRequired,
};

export default WelcomeStep;
